import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, X } from "lucide-react";

// Sticky bottom CTA mirroring the /ebook PreOfferBanner banner: same fixed
// positioning, backdrop blur, hairline border, shadow, spacing and hover
// treatment. Unlike PreOfferBanner, tapping the banner navigates directly
// to the destination — there is no intermediate answer modal. Dismissible
// with the X button.
export default function StickyGetBook({ to = "/free-book" }) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 bg-paper/95 backdrop-blur-md border-t border-hairline shadow-[0_-8px_30px_rgba(10,10,10,0.04)]"
      data-testid="sticky-get-book"
    >
      <button
        type="button"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
        className="absolute top-3 right-4 md:top-4 md:right-6 p-1.5 text-muted hover:text-ink transition-colors"
        data-testid="sticky-get-book-close"
      >
        <X size={18} strokeWidth={1.5} />
      </button>

      <Link
        to={to}
        className="group block w-full text-left cursor-pointer"
        data-testid="sticky-get-book-link"
      >
        <div className="max-w-screen-xl mx-auto px-6 md:px-12 py-6 md:py-7 grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-10 items-center">
          <div className="md:col-span-2 label-mono text-muted">The book</div>
          <h2 className="md:col-span-8 font-display text-xl sm:text-2xl md:text-[1.75rem] lg:text-3xl leading-[1.15] tracking-tight text-ink group-hover:text-leaf transition-colors">
            Get the book
          </h2>
          <div className="md:col-span-2 md:text-right label-mono text-muted group-hover:text-leaf transition-colors flex items-center md:justify-end gap-2">
            Read now
            <ArrowRight size={14} strokeWidth={1.75} />
          </div>
        </div>
      </Link>
    </div>
  );
}
